import { BusRegister } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    busRegisters: [],
    totalCount: 0,
    loading: false,
    query: {}
  },
  actions: {
    async fetch({ commit }, params) {
      const busRegisters = await BusRegister.fetch(params)
      commit('changeState', { busRegisters })
    },
    async count({ commit }, params) {
      const totalCount = await BusRegister.count(params)
      commit('changeState', { totalCount })
    },
    async update({ commit }, { id, ...data }) {
      await BusRegister.update(id, data)
    }
  },
  mutations: {
    setState(state, { attribute, data }) {
      state[attribute] = data
    }
  },
  getters: {}
}
